import { render } from "./DragAndDropSvg.vue?vue&type=template&id=2557f5f8&scoped=true"
import script from "./DragAndDropSvg.vue?vue&type=script&lang=ts"
export * from "./DragAndDropSvg.vue?vue&type=script&lang=ts"

import "./DragAndDropSvg.vue?vue&type=style&index=0&id=2557f5f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2557f5f8"

export default script